import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import TextField from '@material-ui/core/TextField';
import StyledDialog from '../../updateGrRecord/Dialog';
import { FormControlLabel, Radio, RadioGroup, Typography } from '@material-ui/core';
import MandatorySpan from '../../sasl/models/MandatorySpan';

const RejectionRemarks = (props) => {
  const {
    open,
    onClose,
    textLabel,
    title,
    subtitle,
    helperText,
    disabled,
    onTextChange,
    error,
    handleAddReason,
    textValue,
    rejectRadio,
    rejectResubmit,
    handleRejectRadioValue,
    rejectionHeaderText
  } = props;
  return (
    <Dialog open={open} onClose={handleAddReason} fullWidth>
      <StyledDialog
        icon={true}
        handleClose={handleAddReason}
        onClickClose={onClose}
        title={title}
        subtitle={subtitle}
        isButtonDisabled={disabled}
      >
        <form noValidate autoComplete='off'>
          {rejectionHeaderText && 
          <Typography style={{paddingBottom:'10px'}}>
              {rejectionHeaderText}
              <MandatorySpan/>
          </Typography>
          }
          <TextField
            // id='outlined-multiline-static'
            value={textValue}
            label={textLabel}
            multiline
            error={error}
            helperText={helperText}
            rows={4}
            onChange={onTextChange}
            onBlur={(e) => {
              const { name, value } = e.target;
              // Trim leading and trailing spaces for string values
              if (typeof value === "string" && value.trim() !== value) {
                onTextChange({ target: { name, value: value.trim() } });
              }
            }}
            variant='outlined'
            style={{ width: '34.5rem', height: '10rem' }}
          />
          {rejectRadio && 
            <>
            <Typography>
            Allow for resubmission of CoA:<MandatorySpan/>
          </Typography>
          <RadioGroup
            value={rejectResubmit}
            onChange={(e) => handleRejectRadioValue(e)}
              style={{
                flexDirection: "row",
                marginBottom:'1rem',
            }}
          >
            <FormControlLabel value={"Yes"} control={<Radio color="primary" />} label="Yes" />
            <FormControlLabel value={"No"} control={<Radio color="primary" />} label="No" />
            </RadioGroup>
            </>
}
        </form>
      </StyledDialog>
    </Dialog>
  );
};

RejectionRemarks.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onTextChange: PropTypes.func.isRequired,
  handleAddReason: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  textLabel: PropTypes.string,
  subtitle: PropTypes.string,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
};

export { RejectionRemarks };
